import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { ModuleFE_Toaster } from '../../component-modules/ModuleFE_Toaster.js';
export class TS_ToastOverlay extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return { model: this.state?.model };
    }
    __showToast = (model) => {
        this.setState({ model });
        if (!model)
            return;
        const duration = model.duration;
        if (duration <= 0)
            return;
        setTimeout(() => ModuleFE_Toaster.hideToast(model), duration);
    };
    render() {
        const toast = this.state.model;
        if (!toast?.content)
            return null;
        return this.renderToaster(toast);
    }
    renderToaster(toast) {
        return (_jsx("div", { className: "ts-toaster", children: toast.content }));
    }
}
//# sourceMappingURL=TS_ToastOverlay.js.map